import React, { useState, useEffect } from 'react';

const FacilityExclusion = ({
    removeCourtExclusionList,
    addCourtExclusionList,
    setExcludedCourtIds,
    facility,
    excludedCourtIds,
}) => {
    const [checked, setChecked] = useState(true);

    useEffect(() => {
        if (facility?.courts.some(court => !excludedCourtIds.includes(court.id))) {
            setChecked(true);
        } else {
            setChecked(false);
        }
    });

    const toggleFacility = () => {
        let newExcludedIds = excludedCourtIds.filter(courtId => !facility?.courts.some(court => courtId === court.id));
        if (checked === true) {
            newExcludedIds = [...newExcludedIds, ...facility?.courts.map(court => court.id) || {}];
            addCourtExclusionList(newExcludedIds);
        } else {
            const newIncludeIds = facility?.courts.map(court => court.id);
            removeCourtExclusionList(newIncludeIds);
        }

        setExcludedCourtIds(newExcludedIds);
    };

    console.log('excludedCourtIds', excludedCourtIds);
    console.log('facility?.courts', facility?.courts);

    return (
        facility ? (
            <div className="text-semi text-dark flex-grow d-flex aic jcc ml-36 clickable" onClick={() => toggleFacility()} data-testid={`locations.facility-${facility?.id}`}>
                <div className={`radio-check ${checked && 'checked'}`}>
                    <img src="/img/icons/checkmark-icon.svg" />
                </div>
                <div className="lhn" data-testid={`locations.facility-${facility?.id}.name`}>{facility?.name}</div>
            </div>
        ) : (
            <div className="flex-grow" />
        )
    );
};

export default FacilityExclusion;
